import React from "react";
// Default unit is cm^-1 so we need conversion functions from wavenumber to anything else
//exported array of possible units
export default [
  {
    name: (
      <div>
        cm<sup>-1</sup>
      </div>
    ),
    value: "cm^-1"
  },
  { name: "eV", value: "eV"},
  { name: "THz", value: "Thz"},
  { name: "nm", value: "nm"},
  { name: "microns", value: "microns"},
  { name: "ps", value: "ps"},
  { name: "mm", value: "mm"},
];
